import React from "react";
import ContentLoader from "react-content-loader";

const DebtLoadDataFormLoader = () => (
  <ContentLoader
    speed={2}
    width={600}
    height={600}
    viewBox="0 0 600 600"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="20" y="20" rx="4" ry="4" width="200" height="30" />
    <rect x="550" y="20" rx="4" ry="4" width="30" height="30" />

    <rect x="20" y="90" rx="4" ry="4" width="300" height="20" />
    <rect x="20" y="120" rx="4" ry="4" width="150" height="15" />
    <rect x="200" y="120" rx="4" ry="4" width="150" height="15" />

    <rect x="20" y="180" rx="4" ry="4" width="400" height="20" />
    <rect x="20" y="220" rx="4" ry="4" width="150" height="15" />
    <rect x="200" y="220" rx="4" ry="4" width="150" height="15" />

    <rect x="20" y="280" rx="4" ry="4" width="300" height="20" />
    <rect x="20" y="320" rx="4" ry="4" width="250" height="40" />

    <rect x="20" y="400" rx="4" ry="4" width="350" height="20" />
    <rect x="20" y="440" rx="4" ry="4" width="150" height="15" />
    <rect x="200" y="440" rx="4" ry="4" width="150" height="15" />

    <rect x="20" y="480" rx="4" ry="4" width="100" height="40" />
  </ContentLoader>
);

export default DebtLoadDataFormLoader